module.exports = __webpack_public_path__ + "img/Reporting.4175721b.png";